import styled from '@emotion/styled'
import React, { useState } from 'react'

type Props = {
  values: ReadonlyArray<{ displayName: string; value: string }>
  onChange: (selectedIndex: number[]) => void
}

export const TextSelector: React.FC<Props> = ({ onChange, values }) => {
  const [current, setCurrent] = useState<number[]>([])
  const items = values.map((v, index) => {
    return (
      <Item
        onClick={() => {
          const newVal = current.includes(index)
            ? current.filter((c) => c !== index)
            : current.concat(index)
          setCurrent(newVal)
          onChange(newVal)
        }}
        selected={current.includes(index)}
        key={index}
      >
        <Label>{v.displayName}</Label>
      </Item>
    )
  })
  return <Container>{items}</Container>
}

const Container = styled.div`
  width: 100%;
  border: 3px solid #b7d7ea;
  background-color: #fff;
  border-radius: 4px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
`

const Item = styled.div<{ selected: boolean }>`
  display: flex;
  padding: 8px;
  border: 4px solid ${({ selected }) => (selected ? '#b7d7ea' : 'transparent')};
  background-color: transparent;
  border-radius: 4px;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const Label = styled.div`
  font-size: 12px;
  font-weight: bold;
`
